<ng-container *transloco="let t; read:'permit.returnDelegation'">
    <div class="modal">
        <div class="modal__content">
            <div class="modal__title">{{ t("title") }}</div>

            <div class="modal__text">
                {{ t("description") }}
            </div>

            <ha-select
                *ngIf="subscriptionOptions.length > 0"
                class="modal__field"
                [label]="t('subscription')"
                [options]="subscriptionOptions"
                [(ngModel)]="selectedSubscriptionId"
                (ngModelChange)="onSubscriptionChange($event)"
                [ngModelOptions]="{standalone: true}">
            </ha-select>

            <div *ngIf="subscriptionOptions.length > 0" class="modal__roles">
                <div class="modal__roles__item" *ngIf="hasIssuerRole">
                    <ha-checkbox [(ngModel)]="returnIssuerDelegation" [ngModelOptions]="{standalone: true}" [label]="t('issuerRole')">
                    </ha-checkbox>
                </div>

                <div class="modal__roles__item" *ngIf="hasSuperintendentRole">
                    <ha-checkbox [(ngModel)]="returnSuperintendentDelegation" [ngModelOptions]="{standalone: true}" [label]="t('superintendentRole')">
                    </ha-checkbox>
                </div>
            </div>
        </div>

        <div class="modal__actions">
            <button class="modal__actions__close" type="button" (click)="close()">{{ t("cancel") }}</button>
            <button class="modal__actions__save" [class.modal__actions__save--disabled]="!canReturnDelegation" type="button" [disabled]="!canReturnDelegation" (click)="returnDelegation()">{{ t("confirm") }}</button>
        </div>
    </div>
</ng-container>